









































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { storeKonsul } from "@/store/modules/konsul";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";

@Component({})
export default class CardModalDetailKonsul extends Vue {
  @Prop() readonly value!: boolean;

  data = {};

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  get stateuser() {
    return userModule.user;
  }
  get stateKonsul() {
    return storeKonsul.konsul;
  }

  get pasien() {
    return this.stateKonsul?.pasien;
  }

  get canAcceptKonsulForSelf() {
    return (
      this.stateuser.profesi === "Dokter" ||
      this.stateuser.profesi === "Psikolog"
    );
  }

  get listDokterKlinik() {
    return storeDokter.listOnKlinik;
  }

  terima(id, dokterId) {
    this.$emit("terima", id, dokterId);
  }
}
